import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { FamilyProvider } from "@/context/FamilyContext";
import { I18nProvider } from "@/context/I18nContext";
import { CartProvider } from "@/context/CartContext";
import { WishlistProvider } from "@/context/WishlistContext";
import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import IBloomApp from "@/pages/IBloomApp";
import Admin from "@/pages/Admin";
import PublicShop from "@/pages/PublicShop";
import ProductPage from "@/pages/ProductPage";
import CategoryPage from "@/pages/CategoryPage";
import ShopkeepersLanding from "@/pages/ShopkeepersLanding";
import WhyNow from "@/pages/WhyNow";
import HealthInsuranceLanding from "@/pages/HealthInsuranceLanding";
import PrivacyPage from "@/pages/PrivacyPage";
import Directory from "@/pages/Directory";
import AiShelf from "@/pages/AiShelf";
import ShelfScan from "@/pages/ShelfScan";
import ShelfSentry from "@/pages/ShelfSentry";
import ShelfAuto from "@/pages/ShelfAuto";
import WhatsAppFab from "@/components/WhatsAppFab";
import Seo from "@/components/Seo";

const Protected = ({ children, adminOnly = false }) => {
  const { user, loading } = useAuth();
  if (loading) return (
    <div className="min-h-screen flex items-center justify-center text-slate-500">Loading…</div>
  );
  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/app" replace />;
  return children;
};

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <FamilyProvider>
          <I18nProvider>
          <CartProvider>
          <WishlistProvider>
          <BrowserRouter>
            <Toaster position="top-center" richColors />
            <Seo />
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/auth/callback" element={<AuthCallback />} />
              <Route path="/admin" element={<Protected adminOnly><Admin /></Protected>} />
              <Route path="/app" element={<IBloomApp />} />
              <Route path="/shop/:slug" element={<PublicShop />} />
              <Route path="/product/:slug" element={<ProductPage />} />
              <Route path="/category/:slug" element={<CategoryPage />} />
              <Route path="/shopkeepers" element={<ShopkeepersLanding />} />
              <Route path="/why-now" element={<WhyNow />} />
              <Route path="/health-insurance" element={<HealthInsuranceLanding />} />
              <Route path="/privacy" element={<PrivacyPage />} />
              <Route path="/directory" element={<Directory />} />
              <Route path="/ai-shelf" element={<AiShelf />} />
              <Route path="/shelf-scan" element={<ShelfScan />} />
              <Route path="/shelf-sentry" element={<ShelfSentry />} />
              <Route path="/shelf-auto" element={<ShelfAuto />} />
              <Route path="/:city/:shopSlug/:productSlug" element={<ProductPage />} />
              <Route path="/:city/:shopSlug" element={<PublicShop />} />
              <Route path="/" element={<Navigate to="/app" replace />} />
              <Route path="*" element={<Navigate to="/app" replace />} />
            </Routes>
            <WhatsAppFab />
          </BrowserRouter>
          </WishlistProvider>
          </CartProvider>
          </I18nProvider>
        </FamilyProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
